import React from "react";

function CalendarSkeleton({ days = 31 }) {
  const rows = Math.ceil(days / 7);

  return (
    <div className="border border-gray-600 rounded-lg overflow-hidden mt-16">
      {/* Week Header */}
      <div className="grid grid-cols-7 text-center text-sm font-medium text-gray-400  animate-pulse">
        {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((d) => (
          <div className="border py-3 border-gray-700" key={d}>
            &nbsp;
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-2 p-2 ">
        {Array.from({ length: rows * 7 }).map((_, i) => (
          <div
            key={i}
            className="border border-gray-700 rounded flex flex-col items-center justify-center p-3 h-20 bg-cblack5 animate-pulse"
          >
            <div className="h-6 w-6 bg-gray-600 rounded-full mb-2"></div>
            <div className="h-3 w-10 bg-gray-600 rounded"></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CalendarSkeleton;
